import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { SettingsService } from '../../services/settings/settings.service';
import { Router } from '@angular/router';
const THEME_DARK_LOGO = 'assets/images/toro.svg';
const THEME_LIGHT_LOGO = 'assets/images/toro.svg';

@Component({
    selector: 'hub-logo',
    templateUrl: 'hub-logo.component.html',
    styleUrls: ['hub-logo.component.scss'],
})

export class HubLogoComponent {

    @Input() public themeDark: boolean = true;
    @Input() public classes: string = '';
    @Input() public hasLink: boolean = true;
    @Input() public link: string = '';
    @Input() public path: string = '';
    @Input() public externalRouter: boolean = false;
    @Output() public onLogoClick = new EventEmitter<Event>();

    public logoPath: string = '';

    constructor(
        private settingsService: SettingsService,
        private router: Router,
    ) {
        this.logoPath = this.themeDark ? THEME_DARK_LOGO : THEME_LIGHT_LOGO;
    }

    public redirect(url: string) {
        if (this.externalRouter) {
            this.redirectExternal(url);
        } else {
            this.router.navigateByUrl(url);
        }
    }

    public onLogoClickHandler(event: Event) {
        this.onLogoClick.emit(event);
    }

    public clickHandler(event: Event) {
        this.onLogoClick.emit(event);
        this.redirect('/');
    }

    private redirectExternal(url: string) {
        window.location.href = url;
    }
}
